import { useMemo } from "react";

import { SalesMastType } from "@/lib/gql/__generated__/graphql";

import type { SearchTypeForSearchSalesMastList } from "../../constants";
import type * as Model from "../../type";

type QueryData = Model.QueryData;

type Props = {
	queryData: QueryData;
	searchType: SearchTypeForSearchSalesMastList;
};

type Result = {
	queryData: QueryData;
};

export const useFilteredQueryDataBySearchType = ({ queryData: _queryData, searchType }: Props): Result => {
	/**
	 * メルマガ配信希望者の予約に絞り込む
	 */
	const filteredQueryDataBySearchType = useMemo(() => {
		switch (searchType) {
			case "all":
			default:
				return _queryData;
			case "infoEC":
				return _queryData.filter((item) => item.salesMastType === SalesMastType.Ec);
			case "infoReservation":
				return _queryData.filter(
					(item) =>
						item.salesMastType === SalesMastType.ReservationCredit ||
						item.salesMastType === SalesMastType.ReservationLocal,
				);
			case "infoTicketBasic":
				return _queryData.filter((item) => item.salesMastType === SalesMastType.TicketBasic);
			case "infoTicketPro":
				return _queryData.filter((item) => item.salesMastType === SalesMastType.TicketPro);
		}
	}, [_queryData, searchType]);

	return {
		queryData: filteredQueryDataBySearchType,
	};
};
